var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root-novel-list" },
    [
      _c("div", { staticClass: "novel-list-header" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("homePage.novelList.title")))]),
        _c(
          "div",
          { staticClass: "pc flex flex-center" },
          [
            _c(
              "div",
              {
                staticClass: "flex novel-import",
                on: {
                  click: function ($event) {
                    return _vm.onClickImportFile()
                  },
                },
              },
              [
                _c("IconUpload", {
                  staticClass: "flex flex-center mr-5 icon-import",
                }),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("homePage.novelList.importWork"))),
                ]),
              ],
              1
            ),
            _c("memo-button"),
          ],
          1
        ),
      ]),
      _c("novel-list-toolbar", {
        staticClass: "toolbar",
        attrs: {
          "search-query": _vm.searchQuery,
          "sort-key": _vm.sortKey,
          "sort-order": _vm.sortOrder,
          layout: _vm.layout,
          "has-active-filter": _vm.hasActiveFilter,
        },
        on: {
          "update:searchQuery": _vm.onUpdateSearchQuery,
          "update:sortKey": _vm.onUpdateSortKey,
          "update:sortOrder": _vm.onUpdateSortOrder,
          "update:layout": _vm.onUpdateLayout,
          "open-filter": _vm.onOpenFilter,
        },
      }),
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _vm.novels
            ? _c(
                "div",
                {
                  staticClass: "list",
                  class: { "list-view": _vm.layout === "list" },
                },
                [
                  _vm._l(_vm.novels, function (novel) {
                    return [
                      _vm.layout === "grid"
                        ? _c("novel-card", {
                            key: novel.novelId,
                            staticClass: "novel-item",
                            attrs: {
                              novel: novel,
                              "is-menu-open": _vm.openMenuId === novel.novelId,
                            },
                            on: {
                              "toggle-menu-click": _vm.handleToggleMenu,
                              changeLoading: _vm.changeLoading,
                            },
                          })
                        : _c("novel-list-item", {
                            key: "list-" + novel.novelId,
                            attrs: {
                              novel: novel,
                              "is-menu-open": _vm.openMenuId === novel.novelId,
                            },
                            on: {
                              "toggle-menu-click": _vm.handleToggleMenu,
                              changeLoading: _vm.changeLoading,
                            },
                          }),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _c(
            "button-round",
            {
              staticClass: "novel-create tutorial-novel-create",
              attrs: {
                to: { name: "novelCreate" },
                icon: require("@/assets/img/icon/add_book.svg"),
                size: 40,
              },
            },
            [
              _c("div", { staticClass: "pc remove-margin" }),
              _c("span", { staticClass: "sp" }, [
                _vm._v(_vm._s(_vm.$t("homePage.novelList.newWork"))),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm.isLoading
        ? _c("masked-loading", { staticClass: "loading" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }